// extracted by mini-css-extract-plugin
export default {"gallery":"imagesGallery_gallery__-hEdm","galleryItem":"imagesGallery_galleryItem__7FbZC"};